"use client"

import * as React from "react"

const CloseLabelContext = React.createContext("Close")

/** Lets an app translate the screen-reader name of built-in close buttons once; without it the name stays "Close". */
function CloseLabelProvider({ label, children }: { label: string; children: React.ReactNode }) {
  return <CloseLabelContext.Provider value={label}>{children}</CloseLabelContext.Provider>
}

function useCloseLabel() {
  return React.useContext(CloseLabelContext)
}

export { CloseLabelProvider, useCloseLabel }
